/**
 *  <Desription of Service here>
 *
 * @export
 * @class CarouselManager
 */
export class CarouselManager {

  /**
   * $inject to make angular DI minification safe
   *
   * @static
   * @type {Array<string>}
   */
  public static $inject: [string] = ['$log', '$animate'];
  public carousels: Array<any>

  /**
   * @param {$log} $log - Angular logging Service.
   */
  constructor(public $log: any, public $animate: any) {
    this.$log = $log.getInstance('CarouselManager', false);
    this.$log.debug('constructor');
    this.carousels = new Array()
  }

  public add(carousel): void {
    this.$log.debug('add', carousel)

    let c = angular.merge(carousel, { 'isAnimating': false, 'active': false })
    this.carousels.push(c)

    this.setActiveScreen(this.carousels[this.carousels.length - 1], 0)
    return this.carousels[this.carousels.length - 1]
  }

  public getCarouselByKey(key): any {
    this.$log.debug('getCarouselByKey', key)
    return this.carousels.filter((value, index, array) => { return value.key === key })
  }

  public setActiveScreen(carousel: any, index: number): void {
    this.$log.debug('setActiveScreen', carousel, index);
    carousel.items.forEach(this.makeScreenInactive);
    carousel.items[index].active = true;
    carousel.currentItem = carousel.items[index]
  }

  public getActiveScreen(carousel: any): any {
    return carousel.items.filter(this.findActiveScreen)[0];
  }

  public findActiveScreen(element, index, array) {
    return element.active === true;
  }

  public makeScreenInactive(element, index, array) {
    element.active = false
  }

  public isFirstScreen(carousel, item): boolean {
    return this.findScreenIndex(carousel, item) === 0
  }

  public isLastScreen(carousel, item): boolean {
    return this.findScreenIndex(carousel, item) === carousel.items.length;
  }

  public findScreenIndex(carousel, item) {
    return carousel.items.indexOf(item);
  }

  public performNavigation(carousel, command): void {

    this.$log.debug('performNavigation', carousel.currentItem)
    switch (command.toLowerCase()) {
      case 'next':
        this.nextScreen(carousel, carousel.currentItem);
        break;
      case 'previous':
        this.previousScreen(carousel, carousel.currentItem);
        break;
      default:
        break;
    }
  }

  public nextScreen(carousel, currentScreen) {
    let _self: any = this;
    this.$log.debug('nextScreen', currentScreen);

    if ('false' === currentScreen.isLast) {
      currentScreen.$ctrl.onExitStart()
      this.$animate.addClass(currentScreen.$element, currentScreen.exitNextTransition).then(() => {
        _self.$animate.removeClass(currentScreen.$element, 'active ' + currentScreen.exitNextTransition)
        currentScreen.$ctrl.onExitComplete()
      })

      this.switchToScreen({
        'carousel': carousel,
        'command': 'next',
        'currentScreen': currentScreen,
        'futureScreen': carousel.items[this.findScreenIndex(carousel, currentScreen) + 1],
        'futureScreenElement': currentScreen.$element.parent().parent().parent().next().children(0).children(0).children(0)
      })
    }
  }

  public previousScreen(carousel, currentScreen) {
    let _self: any = this;
    this.$log.debug('previousScreen', currentScreen);


    if ('false' === currentScreen.isFirst) {
      currentScreen.$ctrl.onExitStart()
      this.$animate.addClass(currentScreen.$element, currentScreen.exitPreviousTransition).then(() => {
        _self.$animate.removeClass(currentScreen.$element, 'active ' + currentScreen.exitPreviousTransition)
        currentScreen.$ctrl.onExitComplete()
      })

      this.switchToScreen({
        'carousel': carousel,
        'command': 'previous',
        'currentScreen': currentScreen,
        'futureScreen': carousel.items[this.findScreenIndex(carousel, currentScreen) - 1],
        'futureScreenElement': currentScreen.$element.parent().parent().parent()[0].previousElementSibling.children[0].children[0].children[0]
      });
    }

  }

  public switchToScreen(options: any): void {
    let _self: any = this;
    this.$log.debug('switchToScreen', options)
    if (options.carousel.isAnimating) {
      return
    }

    options.carousel.isAnimating = true;

    switch (options.command.toLowerCase()) {
      case 'next':
        options.futureScreen.$ctrl.onEnterStart()
        this.$animate.addClass(options.futureScreenElement, 'active ' + options.futureScreen.enterNextTransition).then(() => {
          _self.$animate.removeClass(options.futureScreenElement, options.futureScreen.enterNextTransition)
          options.carousel.isAnimating = false;
          _self.setActiveScreen(options.carousel, _self.findScreenIndex(options.carousel, options.futureScreen))
          options.futureScreen.$ctrl.onEnterComplete()
        })
        break;
      case 'previous':
        options.futureScreen.$ctrl.onEnterStart()
        this.$animate.addClass(options.futureScreenElement, 'active ' + options.futureScreen.enterPreviousTransition).then(() => {
          this.$animate.removeClass(options.futureScreenElement, options.futureScreen.enterPreviousTransition)
          options.carousel.isAnimating = false;
          _self.setActiveScreen(options.carousel, _self.findScreenIndex(options.carousel, options.futureScreen))
          options.futureScreen.$ctrl.onEnterComplete()
        })
        break;
      default:
        break;
    }
  }

};



/** WEBPACK FOOTER **
 ** ./src/common/services/carousel-manager/carousel-manager.ts
 **/